export class Drag<T> {
    private dragPosition = 0

    onDragStart(ev: DragEvent, i: number) {
        // console.log('onDragStart', ev, i, JSON.stringify(this.arr))
        ev.stopPropagation()
        ev.target instanceof HTMLInputElement ? ev.target.style.cursor = 'move' : null
        this.dragPosition = i
        setTimeout(() => (ev.target as HTMLImageElement).classList.add('moving'), 0)
    }

    onDragEnter(ev: DragEvent, i: number, arr: T[]) {
        // console.log('onDragEnter', i, JSON.stringify(this.arr))
        ev.preventDefault()
        if (!arr) return
        if (this.dragPosition != i) {
            const s = arr[this.dragPosition]
            const t = arr[i]
            arr.splice(i, 1, s)
            arr.splice(this.dragPosition, 1, t)
            this.dragPosition = i
        }
    }

    onDragEnd(ev: DragEvent) {
        (ev.target as HTMLImageElement).classList.remove('moving')
        // console.log('onDragEnd', ev)
    }

    onDragOver(ev: DragEvent) {
        // console.log('onDragOver', ev)
        ev.preventDefault()
        if (ev.dataTransfer) ev.dataTransfer.dropEffect = 'move'
    }
}
